module.exports = ".create-case{background-color:#ffc107;padding-top:6px;padding-bottom:6px;border-radius:5px}\n"